import { asyncLoad } from '@util'

export default {
  path: 'addressStyle',
  indexRoute: {
    component: asyncLoad(() => import('@components/LocalMerchant/AddressStyle'))
  },
  stat: '款式管理',
  childRoutes: [
    {
      path: 'add',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/AddressStyle/addStyle')
      ),
      stat: '款式管理>发布款式'
    },
    {
      path: 'edit/:id',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/AddressStyle/addStyle')
      ),
      stat: '款式管理>编辑款式'
    },
    {
      path: 'auditList',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/AddressStyle/auditList')
      ),
      stat: '款式管理>审核记录'
    }
  ]
}
